type CircleProps = {
  color: string;
  size: number;
  percentage?: number;
};

function Circle({ color, size, percentage = 100 }: CircleProps) {
  const r = size / 2;
  const circ = 2 * Math.PI * r;
  const strokePct = ((100 - percentage) * circ) / 100; // where stroke will start, e.g. from 15% to 100%.

  return (
    <g clipPath="url(#insideCircleOnly)">
      <circle
        r={r}
        cx={0}
        cy={0}
        fill="transparent"
        stroke={strokePct !== circ ? color : ""} // remove color as 0% sets full circumference
        strokeWidth={5}
        strokeDasharray={circ}
        strokeDashoffset={percentage ? strokePct : 0}
        transform={`translate(${size / 2} ${size / 2}) rotate(-90 0 0)`}
      ></circle>
    </g>
  );
}

type ProgressSpinnerProps = {
  percentage?: number;
  className?: string;
};

export default function ProgressSpinner({
  percentage,
  className,
}: ProgressSpinnerProps) {
  const size = 32;
  return (
    <svg
      width={size}
      height={size}
      overflow="visible"
      focusable={false}
      className={className}
    >
      <defs>
        <clipPath id="insideCircleOnly">
          <circle
            cx="0"
            cy="0"
            r={size / 2}
            transform={`translate(${size / 2} ${size / 2})`}
          />
        </clipPath>
      </defs>
      <Circle size={size} color="lightgrey" />
      <Circle size={size} color="gray" percentage={percentage} />
    </svg>
  );
}
